import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleActiveTab } from '../../store/promoSlice.js';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';

import PromotionOrderPanel from './paymentTest2'; // Upewnij się, że ścieżka jest poprawna

import './Promo.css'
import Table from "../../components/list2/table";
import {getHeaders, headerWidths} from "./promoHistoryTableConfig";
import UniversalLineWithComponents
    from "../../components/components/universal_line_with_components/universalLineWithComponents";
import {setSorting, } from "../../store/promoSlice";
import {empty} from "./promoHistoryTableConfig";

function Promo() {
    const dispatch = useDispatch();
    const activeTab = useSelector((state) => state.promo.activeTab);

    const checkedItems = useSelector((state) => state.promo.checkedItems);

    const sortBy = useSelector((state) => state.promo.sortBy);
    const sortDirection = useSelector((state) => state.promo.sortDirection);
    const sortArrowColorActive = '#060606';
    const sortArrowColorInactive = '#06060650';

    const [rows, setRows] = useState([
        [
            <div></div>,
            <div>1</div>,
            <div>24.10.2025</div>,
            <div>Wydarzenie</div>,
            <div>Warszawa</div>,
            <div>89</div>,
            <div>X</div>,
            <div></div>,
        ],
        [
            <div></div>,
            <div>2</div>,
            <div>15.11.2025</div>,
            <div>Koncert Jazzowy</div>,
            <div>Warszawa</div>,
            <div>987</div>,
            <div>X</div>,
            <div></div>
        ],
    ]);

    const [isOrderPanelOpen, setIsOrderPanelOpen] = useState(false);
    const [selectedPlanType, setSelectedPlanType] = useState('Basic');

    const handlePromoteClick = (planName) => {
        setSelectedPlanType(planName);
        setIsOrderPanelOpen(true);
    };

    const headers = getHeaders(
        sortBy,
        sortDirection,
        dispatch,
        setSorting,
        sortArrowColorActive,
        sortArrowColorInactive,
        rows,
        checkedItems,
    );

    const handleSidebarClick = (tabName) => {
        dispatch(toggleActiveTab(tabName));
    };


    return (
    <div>
      <Menu />
      <Content>
        {isOrderPanelOpen ? (
          <PromotionOrderPanel
              initialPlan={selectedPlanType}
              onBack={() => setIsOrderPanelOpen(false)}
          />
        ) : (
        <div className="promo-container">
          <div className="promo-header">
            <h1>Promowanie wydarzeń</h1>
          </div>
          
          <div className="promo-content">
              <div className="promo-sidebar">
                  <div
                      className={`sidebar-item ${activeTab === 'Informacje' ? 'active' : ''}`}
                      onClick={() => handleSidebarClick('Informacje')}
                  >
                      Informacje <span className="right-oriented">&#10217;</span>
                  </div>
                  <div
                      className={`sidebar-item ${activeTab === 'Historia' ? 'active' : ''}`}
                      onClick={() => handleSidebarClick('Historia')}
                  >
                      Historia promowania <span className="right-oriented">&#10217;</span>
                  </div>
              </div>

              {activeTab === 'Informacje' && <div className="promo-main">
              <h2>Wybierz swój plan promowania</h2>
              <p>Wypromuj swoje wydarzenie i dotrzyj do większej liczby odbiorców.</p>
              
              <div className="pricing-cards">
                <div className="pricing-card basic">
                  <div className="card-badge">BASIC</div>
                  <div className="card-subtitle">3 darmowe promowania</div>
                  <div className="card-price">PLN 0</div>
                  <button className="card-button" onClick={() => handlePromoteClick('Basic')}>Promuj wydarzenie →</button>
                  <div className="card-description">
                    Wyróżnienie w danej kategorii przez X dni.
                  </div>
                </div>
                
                <div className="pricing-card standard popular">
                  <div className="card-badge popular-badge">Standard</div>
                  <div className="card-subtitle">Najbardziej popularny</div>
                  <div className="card-price">PLN 9</div>
                  <button className="card-button" onClick={() => handlePromoteClick('Standard')}>Promuj wydarzenie →</button>
                  <div className="card-description">
                    Wyróżnienie w danej kategorii przez X dni + automatyczne odświeżanie
                  </div>
                </div>
                
                <div className="pricing-card medium">
                  <div className="card-badge">Visibility+</div>
                  <div className="card-subtitle"></div>
                  <div className="card-price">PLN 19</div>
                  <button className="card-button" onClick={() => handlePromoteClick('Visibility+')}>Promuj wydarzenie →</button>
                  <div className="card-description">
                    Wyświetlenie na stronie głównej w zakładce <br /> <span className="highlight">Polecane</span> <br />  przez X dni.
                  </div>
                </div>
                
                <div className="pricing-card premium">
                  <div className="card-badge">Premium</div>
                  <div className="card-subtitle"></div>
                  <div className="card-price">PLN 29</div>
                  <button className="card-button" onClick={() => handlePromoteClick('Premium')}>Promuj wydarzenie →</button>
                  <div className="card-description">
                    Wyświetlenie w kategorii <br /> <span className="highlight">Polecane</span> przez X dni, <br /> wyróżnienie w danej kategorii przez X dni + odświeżanie co X dni.
                  </div>
                </div>
              </div>
            </div>}

              {activeTab === 'Historia' && <div className="promo-main">

                  <Table
                      headers={headers}
                      rows={rows}
                      columnWidths={headerWidths}
                      idViewing={false}
                      idArrayId={1}
                      cellClass2='cell-center'
                      cellClass2ConditionList={[4, 5, 6, 7, 8]}
                      tableClass='promo-history-table'
                      tableContainerClass='promo-history-table-container'
                  />


              </div>}

          </div>
        </div>)}
      </Content>
    </div>
  );
}

export default Promo;